﻿export interface IPaymentRequest {
    id:string;
    policyHolderId: string;
    amount: number;
    paymentTokenType: string;
    tokenId: string;
    requestOriginType:string;
    merchantReferenceCode:string;
    requestAt:Date;
    settlementStatus:string

}


export class PaymentRequest implements IPaymentRequest{
    id:string;
    policyHolderId: string;
    amount: number;
    paymentTokenType: string;
    tokenId: string;
    requestOriginType:string;
    merchantReferenceCode:string;
    requestAt:Date;
    settlementStatus:string
}

